<div class="cm-title">
    <ng-content select="[cm-title]"></ng-content>
</div>
<div class="cm-substitle">
    <ng-content select="[cm-subtitle]"></ng-content>
</div>
<i (click)="close.emit()" class="cm-close far fa-times"></i>
<ng-content select="[cm-content]"> </ng-content>
